<template>
    <div class="relative z-10 mx-auto">
        <div class="relative">
            <div aria-hidden="true" class="absolute inset-0 flex flex-col">
                <div class="flex-1"></div>
                <div class="flex-1 w-full"></div>
            </div>
            <div class="mx-auto ">
                <div class="relative">
                    <div class="space-y-8">
                        <div class="flex space-x-6 text-sm rounded">
                            <div class="flex justify-center w-full">
                                <div class="w-full space-y-6">
                                    <div class="relative items-center max-w-5xl mx-auto space-x-3 md:flex">
                                        <div class="flex-1 min-w-0 px-5 md:px-0">
                                            <div class="space-y-1">
                                                <input id="name"
                                                       v-model="queryText"
                                                       @input="onQueryTextChanged"
                                                       autofocus=""
                                                       class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-clay-900 outline-1 -outline-offset-1 outline-clay-300 placeholder:text-clay-900 focus:outline-2 focus:-outline-offset-2 focus:outline-clay-600 sm:text-sm/6"
                                                       name="name"
                                                       placeholder="Filter by college name"
                                                       type="text"/>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="max-w-5xl pb-6 mx-auto md:flex md:items-center md:justify-between">
                                        <div
                                            class="items-center space-y-3 sm:-mx-4 md:flex md:space-y-0">
                                            <PopoverGroup
                                                class="relative block text-center md:text-left md:inline-block">
                                                <Popover class="px-4 ">
                                                  <template #default="{ close }">
                                                    <div
                                                        class="relative block text-center border border-clay-500 md:text-left md:inline-block sm:border-0 ">
                                                        <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 text-sm font-medium text-gray-700 uppercase group hover:text-gray-900 hover:bg-zinc-100 sm:hover:bg-white sm:py-0 sm:bg-white bg-zinc-50">
                                                            <MapPinIcon
                                                                class="w-5 h-5 mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true" />
                                                            <span class="text-gray-700 hover:text-gray-900">Near</span>
                                                            <span v-if="userPreferredRegion.name"
                                                                class=" font-semibold tabular-nums text-gray-700 pl-1.5 underline">{{
                                                                userPreferredRegion.name
                                                                }}</span>

                                                            <a v-if="userPreferredRegion.name"
                                                                class="ml-1 text-sa-red-600"
                                                                @click="clearSelectedRegion">
                                                                <XCircleIcon class="inline h-5 w-5>" />
                                                            </a>

                                                        </PopoverButton>
                                                    </div>
                                                    <transition enter-active-class="transition duration-100 ease-out"
                                                        enter-from-class="transform scale-95 opacity-0"
                                                        enter-to-class="transform scale-100 opacity-100"
                                                        leave-active-class="transition duration-75 ease-in"
                                                        leave-from-class="transform scale-100 opacity-100"
                                                        leave-to-class="transform scale-95 opacity-0">
                                                        <PopoverPanel
                                                            class="z-10 p-4 mt-2 origin-top-left bg-white rounded-md shadow-2xl md:absolute md:w-256 ring-1 ring-black ring-opacity-5 focus:outline-hidden">
                                                            <form class="space-y-4">

                                                                <TerritoriesTab :territories="territories" 
                                                                                v-model="userPreferredRegion"
                                                                                @onRegionSelected="region => onRegionSelected(region, close)" />
                                                            </form>
                                                        </PopoverPanel>
                                                    </transition>
                                                  </template>
                                                </Popover>
                                            </PopoverGroup>
                                        </div>
                                        <div class="sm:block">
                                            <div class="flow-root px-4">

                                                <PopoverGroup
                                                    class="items-center divide-x divide-gray-200 sm:-mx-4 sm:flex">

                                                    <Popover
                                                        class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0 ">
                                                        <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 text-sm font-medium text-gray-700 uppercase group hover:text-gray-900 hover:bg-zinc-100 sm:hover:bg-white sm:py-0 sm:bg-white bg-zinc-50">
                                                            <span>Degree</span>
                                                            <span v-if="request.degrees.length > 0"
                                                                class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700">{{
                                                                request.degrees.length
                                                                }}</span>
                                                            <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true" />
                                                        </PopoverButton>

                                                        <transition
                                                            enter-active-class="transition duration-100 ease-out"
                                                            enter-from-class="transform scale-95 opacity-0"
                                                            enter-to-class="transform scale-100 opacity-100"
                                                            leave-active-class="transition duration-75 ease-in"
                                                            leave-from-class="transform scale-100 opacity-100"
                                                            leave-to-class="transform scale-95 opacity-0">
                                                            <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                                <form class="space-y-4">
                                                                    <div v-for="option in degreeOptions" :key="option"
                                                                        class="flex items-center">
                                                                        <input :id="option" :value="option"
                                                                            v-model="request.degrees" type="checkbox"
                                                                            class="w-4 h-4 text-clay-600 border-2 border-gray-500 rounded focus:ring-clay-500 " />
                                                                        <label :for="option"
                                                                            class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap">{{
                                                                            option
                                                                            }}</label>
                                                                    </div>
                                                                </form>
                                                            </PopoverPanel>
                                                        </transition>
                                                    </Popover>
                                                    <Popover
                                                        class="relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0 ">
                                                        <PopoverButton
                                                            class="inline-flex justify-center min-w-full px-4 py-2 text-sm font-medium text-gray-700 uppercase group hover:text-gray-900 hover:bg-zinc-100 sm:hover:bg-white sm:py-0 sm:bg-white bg-zinc-50">
                                                            <span>Major</span>
                                                            <span v-if="request.majors.length > 0"
                                                                class="ml-1.5 rounded px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white bg-electric-700 hover:bg-electric-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-700">{{
                                                                request.majors.length
                                                                }}</span>
                                                            <ChevronDownIcon
                                                                class="w-5 h-5 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800"
                                                                aria-hidden="true" />
                                                        </PopoverButton>

                                                        <transition
                                                            enter-active-class="transition duration-100 ease-out"
                                                            enter-from-class="transform scale-95 opacity-0"
                                                            enter-to-class="transform scale-100 opacity-100"
                                                            leave-active-class="transition duration-75 ease-in"
                                                            leave-from-class="transform scale-100 opacity-100"
                                                            leave-to-class="transform scale-95 opacity-0">
                                                            <PopoverPanel
                                                                class="z-10 p-4 mt-2 overflow-auto origin-top-right bg-white rounded-md shadow-2xl sm:absolute sm:right-0 ring-1 ring-black ring-opacity-5 focus:outline-hidden max-h-80">
                                                                <form class="space-y-4">
                                                                    <div v-for="option in majorOptions" :key="option"
                                                                        class="flex items-center">
                                                                        <input :id="option" :value="option"
                                                                            v-model="request.majors" type="checkbox"
                                                                            class="w-4 h-4 text-clay-600 border-2 border-gray-500 rounded focus:ring-clay-500" />
                                                                        <label :for="option"
                                                                            class="pr-6 ml-3 text-sm font-medium uppercase text-clay-900 whitespace-nowrap">{{
                                                                            option
                                                                            }}</label>
                                                                    </div>
                                                                </form>
                                                            </PopoverPanel>
                                                        </transition>
                                                    </Popover>

                                                </PopoverGroup>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
    <div ref="resultsSection" class="min-h-screen py-8 bg-zinc-50">
        <div class="max-w-6xl px-4 mx-auto sm:px-6 lg:px-8">
            <p class="mb-6 lg:text-right">Don't see your college? <a href="/pages/contact"
                    class="text-sm font-medium text-gray-700 underline group hover:text-gray-900">Add a new college
                    program </a></p>
            <div v-if="programsRetrieved === true">
                <div v-if="searchCollegeProgramsByFilterResponse.results?.length > 0">
                    <div class="grid grid-cols-1 gap-10 pb-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sp"
                        role="list">


                        <CollegeProgramCard v-for="program in searchCollegeProgramsByFilterResponse.results"
                            :key="program.id" :program="program"></CollegeProgramCard>
                        <!-- More people... -->

                    </div>
                    <paginate v-model="searchCollegeProgramsByFilterResponse.currentPage"
                        :active-class="'border border-electric-700 text-electric-700 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-bold border-x-0 border-b-0'"
                        :click-handler="clickHandler"
                        :container-class="'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-8'"
                        :margin-pages="2"
                        :next-class="'-mt-px w-0 flex-1 flex justify-end'"
                        :next-link-class="'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700'"
                        :next-text="nextHtml"
                        :page-class="'hover:text-clay-900 hover:border-electric-700 hover:border-t-2 hover:border pt-4 px-4 inline-flex items-center text-sm font-medium dark:text-gray-400'"
                        :page-count="getPageCount()"
                        :page-range="3"
                        :prev-class="'-mt-px w-0 flex-1 flex'"
                        :prev-link-class="'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-clay-900 hover:border-electric-700'"
                        :prev-text="prevHtml">
                    </paginate>
                </div>
                <EmptyResultsNotification v-else />
            </div>

            <SkeletonCard v-else :num-of-cards=4 />
        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineComponent, defineProps, onMounted, ref, Ref, watch} from "vue";
import {client} from '@/shared';
import {
    CollegeProgramDtoLightWeight,
    GetAllTerritories,
    SearchCollegeProgramsByFiltersRequest,
    SearchCollegeProgramsByFiltersResponse,
    Region,
} from "@/dtos";
import TerritoriesTab from "@/../Features/Territories/TerritoriesTab.vue";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
// @ts-ignore
import {CheckIcon, SelectorIcon} from '@heroicons/vue/20/solid';
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

import {
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/vue'

import {ChevronDownIcon, MapPinIcon} from '@heroicons/vue/20/solid'
import EmptyResultsNotification from "@/main/components/EmptyResultsNotification.vue";
import CollegeProgramCard from "./CollegeProgramCard.vue";
import {XCircleIcon} from "@heroicons/vue/24/outline";
import {useDebounceFn} from "@vueuse/core";

const open = ref(false)

const props = defineProps({
    majorOptions: Array,
    degreeOptions: Array
});

const queryText = ref('');
const onQueryTextChanged = useDebounceFn(async () => {
    request.value.currentPage = 1;
    request.value.programName = queryText.value;
}, 1000);

const territories: Ref<Array<Region>> = ref([]);
const userPreferredRegion: Ref<Region> = ref({});
const territoryQuery = ref('');

const shouldScroll = ref(false);
const programsRetrieved = ref(false);
const searchCollegeProgramsByFilterResponse = ref(new SearchCollegeProgramsByFiltersResponse({
    results: Array<CollegeProgramDtoLightWeight>()
}));

const request = ref(new SearchCollegeProgramsByFiltersRequest({
    territoryId: '',
    majors: [],
    degrees: [],
}));

const resultsSection = ref(null);

onMounted(async () => {
    await client.get<Array<Region>>(new GetAllTerritories())
        .then(res => {
            territories.value = res.sort((a: Region, b: Region) => a.name.localeCompare(b.name));
        });
});

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? territories.value
        : territories.value.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const onRegionSelected = async (territory: Region ,  closePopover: any) => {
    userPreferredRegion.value = territory;
    request.value.sort = "Distance";
  closePopover();
}

const clearSelectedRegion = async () => {
    userPreferredRegion.value = {};
    request.value.sort = "Popular";
};

const filter = async () => {
    programsRetrieved.value = false;
    
    request.value.territoryId = userPreferredRegion.value.id;

    await client.get<SearchCollegeProgramsByFiltersResponse>(request.value)
        .then(res => {
            programsRetrieved.value = true;
            searchCollegeProgramsByFilterResponse.value = res;
            if(shouldScroll.value){
                resultsSection.value.scrollIntoView({
                    behavior: "smooth"
                });
            }
            shouldScroll.value = true;
        });
}

const resetFilters = async () => {
    request.value = new SearchCollegeProgramsByFiltersRequest({
        territoryId: '',
        majors: [],
        degrees: [],
    });
    userPreferredRegion.value = {};
}

const clickHandler = async (pageNum: any) => {
    request.value.currentPage = pageNum;
    await filter();
}

const getPageCount = () => {
    return Math.ceil(searchCollegeProgramsByFilterResponse.value.totalResults / 12);
}

watch([
        () => request.value.programName,
        () => userPreferredRegion.value,
        () => request.value.majors,
        () => request.value.degrees,
        () => request.value.sort,
    ], async ([]) => {
        request.value.currentPage = 1;
        await filter();
    },
    { immediate: true }
);

const nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

const prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;


</script>
<style>
a {
    cursor: pointer;
}

</style>